import { FormSelect } from '@systemeio/ui'
import EditActionWrapper from 'modules/automation-rules/actions/components/edit-actions/components/edit-action-wrapper'
import { EditActionItemInterface } from 'modules/automation-rules/actions/components/edit-actions/types/edit-action-item-interface'
import { ActionSmsEditInterface } from 'modules/automation-rules/actions/types/automation-rule-actions-edit-interface'
import { SmsTemplateCreateEditModal } from 'modules/automation-rules/sms/sms-template-create-edit-modal'
import { getDataFromObj } from 'modules/automation-rules/utils/get-filter-data'
import { SmsTemplateId } from 'modules/sms/types'
import React from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

interface ActionSmsItemProps extends EditActionItemInterface<ActionSmsEditInterface> {}

const ActionSmsItem = ({
  actions,
  setRules,
  errors,
  idx,
  action,
  onDelete,
}: ActionSmsItemProps) => {
  const { t } = useLocoTranslation()
  return (
    <EditActionWrapper slug={action.type} onDelete={() => onDelete(idx)}>
      {({ data, onOpen, renderActionLabel }) => (
        <FormSelect
          onOpen={onOpen}
          placeholder={t('dashboard.automation_rule.choose_sms_template')}
          label={renderActionLabel({
            label: t('dashboard.automation_rule.sms'),
            additionalLabel: (
              <>
                <SmsTemplateCreateEditModal
                  onSuccess={async data =>
                    setRules(prev => {
                      return {
                        ...prev,
                        actions: actions.map((el, i) => {
                          if (idx === i) {
                            return {
                              ...el,
                              smsTemplate: data,
                            }
                          } else {
                            return el
                          }
                        }),
                      }
                    })
                  }
                />
                {action.smsTemplate.id && (
                  <SmsTemplateCreateEditModal
                    templateId={action.smsTemplate.id}
                    noRedirectOnNotFoundError
                    onSuccess={async data =>
                      setRules(prev => {
                        return {
                          ...prev,
                          actions: actions.map((el, i) => {
                            if (idx === i) {
                              return {
                                ...el,
                                smsTemplate: data,
                              }
                            } else {
                              return el
                            }
                          }),
                        }
                      })
                    }
                  />
                )}
              </>
            ),
          })}
          value={action.smsTemplate.id}
          staticData={getDataFromObj({
            id: action.smsTemplate.id,
            name: action.smsTemplate.name,
          })}
          data={data.smsTemplateData}
          onChange={data =>
            setRules(prev => {
              return {
                ...prev,
                actions: actions.map((el, i) => {
                  if (idx === i) {
                    return {
                      ...el,
                      smsTemplate: {
                        ...action.smsTemplate,
                        id: data as unknown as SmsTemplateId,
                      },
                    }
                  } else {
                    return el
                  }
                }),
              }
            })
          }
          error={errors.automationActions[action.id]?.smsTemplateId?.join('') || ''}
        />
      )}
    </EditActionWrapper>
  )
}

export default ActionSmsItem
